import Cookies from "js-cookie";
import {
    EmbedDataProps,
    GroupScheme,
    mapEmbedArrToEmbedObj,
    mapSchemes,
    mapSchemesToEmbedDisplayObj,
} from "./handleSchemes";
import { VISITOR_COOKIE_NAME } from "@/config/constConf";
import { HandlePhpFetch } from "../fetch";
import { SCHEME } from "@/config/api";
import { getVistorId, isLogin } from "@/src/models";
import { getUid } from "@/src/models/personalize";
import acquisition from "@/src/components/LoadAnalysis/analysis/DataAcquisition";
import { getCookieItem, setCookieItem } from "@/lib/commonService";

export interface IInnerAddsProps {
    searchParams: Record<string, string | string[]>;
    page_url?: string;
    customerId?: number;
}

export interface InnerAddsDataProps {
    embedData?: EmbedDataProps;
    alertData?: GroupScheme[];
    visitorId?: number;
    pathname?: string;
}

// 客户端获取站内方案
export default async function getInnerAddsSchemes({
    searchParams,
    page_url,
    customerId,
}: IInnerAddsProps): Promise<InnerAddsDataProps | undefined> {
    try {
        let alertData, embedData;
        let visitorId = getVistorId();
        let pathname = page_url;
        if (!pathname?.startsWith("/")) {
            pathname = "/" + pathname;
        }
        const store: any = {
            path: pathname,
            search:
                Object.keys(searchParams).length === 0
                    ? ""
                    : JSON.stringify(searchParams),
            visitorId,
            customerId,
        };

        const historySchemesStr = getCookieItem("HISTORY_SCHEMSES_SHOW");
        if (historySchemesStr && historySchemesStr != "undefined") {
            store.scheme_data = historySchemesStr;
        }

        const schemes_data = await HandlePhpFetch.get(
            `/${SCHEME}-new?${new URLSearchParams(store)}`,
        );
        if (schemes_data.visitorId && visitorId != schemes_data.visitorId) {
            visitorId = schemes_data.visitorId;
            Cookies.set(
                VISITOR_COOKIE_NAME,
                JSON.stringify({ visitor_id: visitorId }),
                {
                    expires: 30 * 12,
                },
            );
            if (!isLogin()) {
                const uid = getUid();
                const userId = uid ? "U" + uid : "V" + visitorId;
                acquisition.login("UserId ", userId);
            }
        }

        if (schemes_data.schemes && schemes_data.schemes?.length > 0) {
            const schemes = checkSchemesShowByHistoryNumber(
                schemes_data.schemes,
            );
            const schemesClassify = mapSchemes(schemes);
            // 弹出弹窗
            if (schemesClassify.hasAlert) {
                alertData = schemesClassify.alertArr;
            }
            // 展示嵌入
            if (schemesClassify.hasEmbed) {
                const embedDisplayArr = mapSchemesToEmbedDisplayObj(
                    schemesClassify.embedArr,
                );
                const embedDisplayObj = mapEmbedArrToEmbedObj(embedDisplayArr);
                embedData = embedDisplayObj;
            }
        }
        return { embedData, alertData, visitorId, pathname };
    } catch (e) {
        return undefined;
    }
}

/**
 *
 * 站内方案优化，后端返回的方案中，有些方案需要根据历史展示次数来判断是否展示
 * 通过cookie记录每个方案的展示次数，如果超过了方案的最大展示次数，则不展示
 * 减少后端查询大表的压力
 * @param {
 * data: Array<{
 * group_scheme_id: number,
 * scheme_max_times: number
 * }>
 * }
 * @returns data
 */
const checkSchemesShowByHistoryNumber = (data?: InnerAddsDataProps) => {
    if (!data || !Array.isArray(data)) {
        return [];
    }

    const historySchemesStr = getCookieItem("HISTORY_SCHEMSES_SHOW");
    let historySchemes =
        historySchemesStr && historySchemesStr != "undefined"
            ? JSON.parse(historySchemesStr)
            : {};

    const showData = data.filter((item) => item.scheme_max_times > 0);

    for (let index = 0; index < showData.length; index++) {
        const element = showData[index];
        const { group_scheme_id, scheme_max_times = 0 } = element;

        if (historySchemes[group_scheme_id]) {
            historySchemes[group_scheme_id] =
                historySchemes[group_scheme_id] + 1;
        } else {
            historySchemes[group_scheme_id] = 1;
        }
        if (historySchemes[group_scheme_id] > scheme_max_times) {
            showData.splice(index, 1);
            index--;
        }
    }
    const time = new Date(new Date().getTime() + 365 * 24 * 3600 * 1000);
    setCookieItem("HISTORY_SCHEMSES_SHOW", JSON.stringify(historySchemes), {
        path: "/",
        expires: time,
    });
    return showData;
};
